import React, { useState, useEffect } from "react";
import "../master.scss";
import { _Api, graphqlPost } from "../../api/_call";
import Select from "react-select";
import { error, loading, Updateloading } from "../../common/helpers/toastify";
import { useTranslation } from "react-i18next";

const Edittraceability = (props) => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const {
    setEditItem,
    showedit,
    shape,
    activeshow,
    dataid,
    type,
    setShowedit,
    create,
    setCreate,
    setDataid,
  } = props;
  console.log(dataid, "dataid");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [description, setDescription] = useState();
  const [file, setFile] = useState();
  const [active, setActive] = useState(true);
  const { t } = useTranslation();
  const edittraceabilityarea = async () => {
    if (!name) {
      error(t("Name is required."));
      return;
    }
    if (!code) {
      error(t("Code is required."));
      return;
    }
    // else {
    //   if (typeof code === 'string') {
    //     let checkspace = code.includes(' ');
    //     if (checkspace) {
    //       error(t('Please remove space in code'));
    //       return;
    //     }
    //   }
    // }
    setShowedit(false);
    let GetloadingID = loading();
    const postdata = {
      id: dataid ? dataid : "",
      type: type ? type : "",
      name: name ? name : "",
      code: code ? code : "",
      Status: active ? "1" : "0",
      edit: dataid ? true : false,
      image: file ? file : "",
    };
    let res = await _Api(postdata, `api/v1/App/master/traceabilityMasteredit`);
    if (res?.code === 200) {
      setEditItem(false);
      setShowedit(true);
      Updateloading(t, GetloadingID, res?.message);
      setCreate(false);
      setDataid("");
    } else {
      Updateloading(t, GetloadingID, res.errors, "error");
    }
  };
    const onImageChange = (e) => {
      const [file] = e.target.files;
      const reader = new FileReader(file);
      reader.onloadend = async () => {
        try {
          const postdata = {
            image: reader.result,
            name: name,
          };
          let resfront = await _Api(postdata, `api/v1/APP/customer/uploadimagesvg`);
          if (resfront.code === 200) {
            setFile(resfront?.data?.images?.url);
          }
        } catch (err) {
          console.log(err, "err");
        }
      };
      if (file) {
        reader?.readAsDataURL(file);
      }
    };
  const viewmaster = async () => {
    if (create) {
      setName("");
      setFile("");
      setCode("");
      setActive(true);
      setDescription("");
    } else if (dataid && type) {
      try {
        const postdata = {
          type: type,
          id: dataid,
        };
        const res = await _Api(
          postdata,
          `api/v1/App/master/traceabilityMasterViewById`
        );
        if (res?.code === 200) {
          setFile(res?.data?.image);
          setName(res?.data?.name);
          setCode(res?.data?.code);
          if (res?.data?.Status === "1") {
            setActive(true);
          } else {
            setActive(false);
          }
          setDescription(res?.data?.description);
        }
      } catch (err) {
        console.log(err, "err");
      }
    }
  };

  useEffect(() => {
    if (type && (dataid || create)) {
      viewmaster();
    }
    // eslint-disable-next-line
  }, [dataid, type, create]);

  return (
    <>
      <div className="edit-item-area bg-white">
        <div className="edit-item-area-header d-flex align-items-center justify-space-between mb-4">
          <div className="me-auto">
            <label className="d-block">
              {t("Name")}: {name ? name : ""}
            </label>
            <label className="d-block">
              {t("Code")}: {code ? code : ""}
            </label>
          </div>
          <button
            className="square-btn square-btn-white btn-close focus-none"
            onClick={() => {
              setEditItem(false);
              setDataid("");
              setCreate(false);
            }}
          ></button>
          <button
            className="square-btn "
            onClick={() => {
              setEditItem(false);
              setDataid("");
              setCreate(false);
              edittraceabilityarea();
            }}
          >
            <img src={base_assets + "images/icons/white-save.png"} alt="" />
          </button>
        </div>
        <div className="edit-item-area-body">
          <div className="row mx-0">
             <div className="col-md-3 ps-0">
              <div className="edit-item-area-body-img p-2 d-flex align-items-center justify-content-center">
                <img
                  className="position-absolute"
                  src={base_assets + "images/icons/add-img-circle.png"}
                  alt=""
                />
                <label
                  className=" d-block h-100 w-100 cursor-pointer"
                  style={{ zIndex: "1" }}
                  htmlFor="itemImgChoose"
                >
                  <img
                    className={
                      file ? "w-100 h-100 bg-white object-fit-cover" : "d-none"
                    }
                    src={
                      file
                        ? file
                        : base_assets + "images/icons/add-img-circle.png"
                    }
                    alt=""
                  />
                </label>
                <input
                  type="file"
                  id="itemImgChoose"
                  className="d-none"
                  accept=".svg,image/svg+xml"
                  onChange={onImageChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="v3-input-group">
                <label className="v3-input-group-label">
                  {t("Name")} <sup>*</sup>
                </label>
                <input
                  className="v3-input-group-input w-100"
                  value={name || ""}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="v3-input-group">
                <label className="v3-input-group-label">
                  {t("Code")} <sup>*</sup>
                </label>
                <input
                  className="v3-input-group-input w-100"
                  value={code || ""}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3 pe-0 text-end">
              <div className="form-check form-switch ps-0">
                <label className="form-check-label" htmlFor="active">
                  {t("Active")}
                </label>
                <input
                  className="form-check-input float-none ms-2"
                  type="checkbox"
                  id="active"
                  checked={active ? true : false}
                  onChange={(e) => setActive(e.target.checked)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edittraceability;
